import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

import {
  DefaultConfirmPulverizationForm,
  schema,
} from './confirm-pulverization-schema'

export function useConfirmPulverizationForm() {
  const methods = useForm<DefaultConfirmPulverizationForm>({
    resolver: zodResolver(schema),
  })

  return methods
}
